export default {
	ClickOrDrop: 'Click here or drop a file...',
	Error: 'Upload error:',
	Close: 'Close',
	UnknownError: 'Unknow error. \n Please contact the support',
	ErrorImgName:
		'Error name of image is not valid. \n Special characters and space not authorized',
};
